import React from "react"
import PropTypes from "prop-types"

class PhoneReplace extends React.Component {
  constructor(props) {
    super(props);
    this._last_sqs_message = null;
    this.state = {
      isLoading: false,
      phone: "",
      dashboard_session_id: props.dashboard_session_id
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handlePhoneChange = (e) => { this.setState({ ...this.state, phone: e.target.value }); console.log("target is:"+e.target.value)  };

  async handleSubmit(e) {
    e.preventDefault();
    fetch("/api/v2/phone_replace", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ search: this.state.phone}),
      })
        .then((response) => {
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
            console.log("parsed json data is "+JSON.stringify(data));
            if (data["error"]) {
                window.alert(data["error"]);
            }
            else if (data["message"]) {
                window.alert(data["message"]);
                this.setState({phone: ""})
            }
            else {
                window.alert("Unexpected server response: "+JSON.strinfigy(data));
            }

        })
        .catch((error) => {
          console.error(error);
          window.alert("Server error: "+error);
          this.setState({ ...this.state, loading: false});
        });
  }

  render () {
    console.log("start render")
    var header = "";
      console.log("returning from render")
      return (
        <React.Fragment>
        <div id="phone_replace" className={this.state.isLoading ? "loading" : "done-loading"}>
        {header}
        <h1>Phone Number Clear Utility</h1>
        <p>This utility will clear out any phone number in the site app and backend databases (in member and credential records) so it can be once again tested as an unused phone number. Phone numbers may be entered in US (202-111-2222) or international (+12021112222) formats.</p>
        <form onSubmit={this.handleSubmit}>

            <div className="form-group">
              <input
                value={this.state.phone}
                placeholder="ex: 111-222-3333"
                onChange={this.handlePhoneChange}
                type="text"
                name="phone"
                className="form-control"
              />
            </div>

          <button
            className="btn btn-primary"          >
            Clear Phone
          </button>
        </form>
        </div>
        </React.Fragment>
      );
  }

  componentDidMount() {
    console.log("component mount start")
    console.log("component mount end")
  }

}

PhoneReplace.propTypes = {
  greeting: PropTypes.string
};
export default PhoneReplace
